import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout for /workflows and /workflows/$id — just an outlet so the index (list) and
// the detail page render as proper siblings (not nested inside the list).
export const Route = createFileRoute("/workflows")({
  component: () => <Outlet />,
});
